const loadView_G = view => {
  return () =>
    import(/* webpackChunkName: "viewG-[request]" */ `@GV/Error/${view}.vue`)
}

export default [
  {
    path: '/500',
    name: '500',
    component: loadView_G('Error500')
  },
  {
    path: '/404',
    name: '404',
    component: loadView_G('Error404')
  },
  {
    path: '/Maintain',
    name: 'Maintain',
    component: loadView_G('Maintain')
  },
  {
    path: '*',
    component: loadView_G('Error404')
  }
]
